var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFileDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F1F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15450_24643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 23.3332L20 19.9999M20 19.9999L16.6667 23.3332M20 19.9999V27.4999M26.9917 25.3249C27.8044 24.8818 28.4465 24.1806 28.8166 23.3321C29.1866 22.4835 29.2635 21.5359 29.0352 20.6388C28.8068 19.7417 28.2862 18.9462 27.5556 18.3778C26.8249 17.8094 25.9257 17.5005 25 17.4999H23.95C23.6978 16.5243 23.2276 15.6185 22.575 14.8507C21.9223 14.0829 21.104 13.4731 20.1817 13.0671C19.2595 12.661 18.2571 12.4694 17.2501 12.5065C16.2431 12.5436 15.2576 12.8085 14.3676 13.2813C13.4777 13.7541 12.7066 14.4225 12.1122 15.2362C11.5178 16.05 11.1156 16.9879 10.9358 17.9794C10.7561 18.9709 10.8034 19.9903 11.0743 20.961C11.3453 21.9316 11.8327 22.8281 12.5 23.5832",
    stroke: "#9FA0A7",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15450_24643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileDisabled);
export default __webpack_public_path__ + "static/media/upload-file-disabled.d95e06995631c33d2049cc5857a0fd57.svg";
export { ForwardRef as ReactComponent };